import {EstimateOptionsSelectorComponent} from "./EstimateOptionsSelectorComponent";
import React, {useEffect, useState} from "react";
import {CountertopControl} from "./countertop/CountertopControl";
import {EdgesControl} from "./edges/EdgesControl";
import {SinksControl} from "./sinks/SinksControl";
import './EEProToolForm.scss'
import {useCountertops} from "../contexts/countertopsContext";
import {RadiiControl} from "./radii/RadiiControl";
import {OptionsControl} from "./options/OptionsControl";
import {TotalControl} from "./total/TotalControl";
import {CutoutsControl} from "./cutouts/CutoutsControl";
import {NoteControl} from "./note/NoteControl";
import {MaterialComparisonControl} from "./material-comparison/MaterialComparisonControl";
import {DealerSelectorControl} from "./dealer-selector/DealerSelectorControl";
import {useParams} from "react-router-dom";
import {CompanyTypes} from "../../../../types/enums";
import {useAuth} from "../../../../contexts/auth";
import {CustomerInformationControl} from "./customer-information/CustomerInformationControl";

export function EEProToolForm() {
    const context = useCountertops();
    const {quoteId} = useParams();
    const {user} = useAuth();

    useEffect(() => {
        if (user?.companyTypeId === CompanyTypes.DEALER) {
            context.setDealerId(user.companyId ?? 0);
        }
    }, [user?.companyId])

    return (
        <div className={'content-block'} id={'EEPro'}>
            <EstimateOptionsSelectorComponent/>
            {
                (user?.companyTypeId !== CompanyTypes.DEALER && (context.dealerId === 0 || quoteId === undefined)) &&
                <div className={'dx-card content'} style={{padding: '10px'}}>
                    <DealerSelectorControl/>
                </div>
            }
            {context.isNewEstimate ? <div className={'dx-card content'} style={{padding: '10px'}}>
                <CustomerInformationControl></CustomerInformationControl>
            </div> : <></>}
            <div className={'dx-card content countertop-control'} style={{padding: '10px'}}>
                <CountertopControl></CountertopControl>
            </div>
            <div className={'dx-card content'} style={{padding: '10px'}}>
                <EdgesControl></EdgesControl>
            </div>
            {context.showSinks ? <div className={'dx-card content'} style={{padding: '10px'}}>
                <SinksControl></SinksControl>
            </div> : <></>}
            {context.showCutouts ? <div className={'dx-card content'} style={{padding: '10px'}}>
                <CutoutsControl></CutoutsControl>
            </div> : <></>}
            {context.showSafetyCorners ? <div className={'dx-card content'} style={{padding: '10px'}}>
                <RadiiControl></RadiiControl>
            </div> : <></>}
            {context.showFinishingTouches ? <div className={'dx-card content'} style={{padding: '10px'}}>
                <OptionsControl></OptionsControl>
            </div> : <></>}
            <div className={'dx-card content'} style={{padding: '10px'}}>
                <NoteControl></NoteControl>
            </div>
            <div className={'dx-card content total-control'} style={{padding: '10px'}}>
                <TotalControl></TotalControl>
            </div>
            <div className={'dx-card content'} style={{padding: '10px'}}>
                <MaterialComparisonControl></MaterialComparisonControl>
            </div>
        </div>
    );
}
